
import { computed, defineComponent } from 'vue';
import axios from 'axios'
import { useStore } from '../store/index'
import { useRouter } from 'vue-router'
export default defineComponent({
  name: 'Index',
  setup() {
    const store = useStore()
    const router = useRouter()
    const user = computed(() => store.state.user)
    const logout = () => {
      axios.get('/api/logout').then(() => {
        store.commit('logout')
        router.push('/login')
        window.location.reload()
      })
    }
    return {
      user,
      logout
    }
  }
});
